import { render, staticRenderFns } from "./pedir-anulacion.vue?vue&type=template&id=48df805e&scoped=true"
import script from "./pedir-anulacion.vue?vue&type=script&lang=js"
export * from "./pedir-anulacion.vue?vue&type=script&lang=js"
import style0 from "./pedir-anulacion.vue?vue&type=style&index=0&id=48df805e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48df805e",
  null
  
)

export default component.exports